// Forge-specific Jira Cloud (Forge) data access helpers.
//
// These functions encapsulate calls that differ between Jira Cloud (Forge)
// and Jira Cloud. They are used by processMiner.js.

function enc(v) {
  return encodeURIComponent(v ?? '');
}

/** Load activity types using a Forge resolver. */
export async function getActivityTypesForge(loadForgeModule) {
  const { invoke } = await loadForgeModule();
  return await invoke('getActivityTypes');
}

/** Retrieve a analysis model using a Forge resolver. Returns the first model object. */
export async function getProcessModelForge(loadForgeModule, modelID) {
  const { invoke } = await loadForgeModule();
  const res = await invoke('getProcessModel', { modelID });
  if (Array.isArray(res)) return res[0];
  return res;
}

/** Retrieve a calendar using a Forge resolver. */
export async function getCalendarForge(loadForgeModule, calendarID) {
  const { invoke } = await loadForgeModule();
  // Resolver expects payload.id (not calendarID); returns rows array — unwrap first row.
  const rows = await invoke('getCalendar', { id: calendarID });
  return Array.isArray(rows) ? rows[0] : rows;
}

/** Retrieve the Jira base URL (serverInfo.baseUrl) for the current Forge tenant. */
export async function getJiraBaseUrlForge(loadForgeModule) {
  const { requestJira } = await loadForgeModule();
  const response = await requestJira('/rest/api/3/serverInfo');
  if (!response.ok) {
    throw new Error(`Failed to fetch server info: ${response.status}`);
  }
  const data = await response.json();
  return data?.baseUrl || '';
}

/** Get total issue count using the v3 approximate-count endpoint. */
export async function getTotalIssueCountForge(loadForgeModule, jql) {
  const { requestJira } = await loadForgeModule();
  const response = await requestJira('/rest/api/3/search/approximate-count', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ jql }),
  });
  if (!response.ok) {
    throw new Error(`Failed to get issue count: ${response.status}`);
  }
  const countData = await response.json();
  return countData?.count ?? 0;
}

/** Fetch a page of issues using the v3 JQL search endpoint with token pagination. */
export async function fetchIssueBatchForge(loadForgeModule, jql, fieldsStr, propertiesStr, nextPageToken) {
  const { requestJira } = await loadForgeModule();
  const paginationParam = nextPageToken ? `&nextPageToken=${enc(nextPageToken)}` : '';

  let requestStr = `/rest/api/3/search/jql?jql=${enc(jql)}&maxResults=100&fields=${enc(fieldsStr)}${paginationParam}&expand=changelog`;
  if (propertiesStr) {
    requestStr += `&properties=${enc(propertiesStr)}`;
  }

  const response = await requestJira(requestStr);
  if (!response.ok) {
    throw new Error(`Failed to fetch issues: ${response.status}`);
  }
  return await response.json();
}